import styles from './Toolbar.module.scss';
import CustomDropdown from '../../../../ui/CustomDropdown/CustomDropdown';
import { Link } from '@sitecore-jss/sitecore-jss-react';

export default function Toolbar({ options, onSelect }) {
  const handleSelect = (option) => {
    onSelect(option);
  };

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div className={styles.customDropdown}>
        <CustomDropdown options={options} onSelect={handleSelect} />
      </div>

      <div className={styles.right}>
        <Link href="/about-us">Our company</Link>
        <Link href="/contact-us">Contact us</Link>
      </div>
    </div>
  );
}
